/* =========================================================================
   RETAILER × StockX — sneaker size-type toggle (US / UK / EU / CM)
   Sizes are stored US-native on the "Size" variant option (e.g. "US9",
   "US10 (Damaged box)", "9.5W", "7Y"). UK/EU/CM are derived client-side from
   a static conversion table and rewritten onto the size chips. Footwear-only
   (gated in Liquid). Unmappable sizes fall back to their original US label.
   ========================================================================= */
(function () {
  'use strict';

  // US men's size -> [UK, EU, CM]
  var M = {
    '3.5': ['3', '35.5', '22.5'], '4': ['3.5', '36', '23'], '4.5': ['4', '36.5', '23.5'],
    '5': ['4.5', '37.5', '23.5'], '5.5': ['5', '38', '24'], '6': ['5.5', '38.5', '24'],
    '6.5': ['6', '39', '24.5'], '7': ['6', '40', '25'], '7.5': ['6.5', '40.5', '25.5'],
    '8': ['7', '41', '26'], '8.5': ['7.5', '42', '26.5'], '9': ['8', '42.5', '27'],
    '9.5': ['8.5', '43', '27.5'], '10': ['9', '44', '28'], '10.5': ['9.5', '44.5', '28.5'],
    '11': ['10', '45', '29'], '11.5': ['10.5', '45.5', '29.5'], '12': ['11', '46', '30'],
    '12.5': ['11.5', '47', '30.5'], '13': ['12', '47.5', '31'], '13.5': ['12.5', '48', '31.5'],
    '14': ['13', '48.5', '32'], '15': ['14', '49.5', '33'], '16': ['15', '50.5', '34'],
    '17': ['16', '51.5', '35'], '18': ['17', '52.5', '36']
  };
  // US GS / Youth -> [UK, EU, CM]. UK youth runs ~0.5 below US (caps at UK6 for
  // 6.5Y/7Y), per the standard Nike GS chart. 2026-06-16 (Owen): youth UK added.
  var GS = {
    '3.5': ['3', '35.5', '22.5'], '4': ['3.5', '36', '23'], '4.5': ['4', '36.5', '23.5'], '5': ['4.5', '37.5', '23.5'],
    '5.5': ['5', '38', '24'], '6': ['5.5', '38.5', '24'], '6.5': ['6', '39', '24.5'], '7': ['6', '40', '25']
  };

  // adidas US men's -> [UK, EU, CM] (adidas chart: UK = US - 0.5, EU in thirds). 2026-11-04 (Owen): Samba sizes read wrong on the Nike table.
  var AD = {
    '4': ['3.5', '36', '22'], '4.5': ['4', '36⅔', '22.5'], '5': ['4.5', '37⅓', '23'], '5.5': ['5', '38', '23.5'], '6': ['5.5', '38⅔', '24'], '6.5': ['6', '39⅓', '24.5'], '7': ['6.5', '40', '25'], '7.5': ['7', '40⅔', '25.5'], '8': ['7.5', '41⅓', '26'], '8.5': ['8', '42', '26.5'], '9': ['8.5', '42⅔', '27'], '9.5': ['9', '43⅓', '27.5'], '10': ['9.5', '44', '28'], '10.5': ['10', '44⅔', '28.5'], '11': ['10.5', '45⅓', '29'], '11.5': ['11', '46', '29.5'], '12': ['11.5', '46⅔', '30'], '12.5': ['12', '47⅓', '30.5'], '13': ['12.5', '48', '31'], '13.5': ['13', '48⅔', '31.5'], '14': ['13.5', '49⅓', '32'], '14.5': ['14', '50', '32.5'], '15': ['14.5', '50⅔', '33']
  };
  var BRAND = '';

  function parse(raw) {
    if (!raw) return null;
    var note = '';
    var nm = raw.match(/\(([^)]*)\)/);
    if (nm) note = ' (' + nm[1] + ')';
    var v = raw.replace(/\([^)]*\)/, '').trim();
    var g = 'M';
    if (/Y$/i.test(v)) { g = 'Y'; v = v.replace(/Y$/i, ''); }
    else if (/W$/i.test(v)) { g = 'W'; v = v.replace(/W$/i, ''); }
    v = v.replace(/^US\s?/i, '').trim();
    var num = parseFloat(v);
    if (isNaN(num)) return null;
    return { num: num, g: g, note: note };
  }
  function key(n) { return String(n).replace(/\.0$/, ''); }

  function convert(raw, sys) {
    if (sys === 'US') return raw.replace(/^US\s?/i, 'US').trim();
    var p = parse(raw);
    if (!p) return null;
    if (p.g === 'Y') {
      var r = GS[key(p.num)];
      if (!r) return null;
      return (sys === 'UK' ? 'UK' + r[0] : sys === 'EU' ? 'EU' + r[1] : r[2] + 'cm') + p.note;
    }
    var ad = BRAND === 'adidas';
    var menNum = p.g === 'W' ? p.num - (ad ? 1 : 1.5) : p.num;
    var row = (ad ? AD : M)[key(menNum)];
    if (!row) return null;
    var val = sys === 'UK' ? 'UK' + row[0] : sys === 'EU' ? 'EU' + row[1] : row[2] + 'cm';
    return val + p.note;
  }

  function SxSizeToggle() { return Reflect.construct(HTMLElement, [], SxSizeToggle); }
  SxSizeToggle.prototype = Object.create(HTMLElement.prototype);
  SxSizeToggle.prototype.constructor = SxSizeToggle;

  // SINGLETON OWNER. Footwear gh3 PDPs render the Dawn `main-product` section
  // hidden alongside the visible gh3 section — and BOTH render an
  // <sx-size-toggle>. Two instances connected, each with its own MutationObserver
  // and its own `current`, both rewriting the SAME global `.gh2__sizes [data-v]`
  // chips (gh3apply uses document-wide selectors). The hidden Dawn toggle's
  // observer (current='US') fired on the visible toggle's relabel and reverted
  // the chips back to US — so tapping UK/EU/CM looked like it "did nothing".
  // Only ONE instance may wire up. Prefer the gh3 toggle (the real buy surface);
  // otherwise first-connected wins. Later instances stay inert.
  function isGh3(el) { return /gh3/i.test(el.getAttribute('data-section') || ''); }
  var _owner = null;

  SxSizeToggle.prototype.connectedCallback = function () {
    BRAND = (this.getAttribute('data-brand') || '').toLowerCase();
    var self = this;
    // Claim ownership: a gh3 instance always wins (even over an earlier non-gh3
    // owner); a non-gh3 instance only wins if nothing has claimed yet.
    if (_owner && _owner !== this) {
      if (!isGh3(this) || isGh3(_owner)) return; // stay inert
      if (_owner._teardown) _owner._teardown(); // gh3 supersedes a non-gh3 owner
    }
    _owner = this;
    this._teardown = function () {
      if (self.mo) { self.mo.disconnect(); self.mo = null; }
      _owner = (_owner === self) ? null : _owner;
    };
    this.current = 'US';
    this.tabs = this.querySelectorAll('.sx-size-toggle__tab');
    this.tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        self.tabs.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
        t.classList.add('is-active');
        t.setAttribute('aria-selected', 'true');
        // GUARD the click too. apply() rewrites the hidden Dawn label spans,
        // which live INSIDE the observed variant-radios container — without this
        // guard that mutation re-fires the MutationObserver, which re-enters
        // stamp()+apply() and leaves _applying stuck true, so the relabel is lost
        // / lags a click behind (the "tab does nothing" bug).
        self._applying = true;
        self.apply(t.getAttribute('data-sys'));
        setTimeout(function () { self._applying = false; }, 0);
      });
    });
    var chart = this.querySelector('[data-sx-open-chart]');
    if (chart) chart.addEventListener('click', openChart);
    this._applying = false;
    this.stamp();
    this.apply('US');
    // Observe a STABLE container (variant-radios persists; Dawn swaps its inner
    // fieldset on variant change). The _applying guard stops our OWN label
    // rewrites (textContent = a childList mutation) from re-triggering the
    // observer — without it the observer loops and FREEZES the tab on click.
    var fs = this.fieldset();
    var container = document.querySelector('variant-radios, variant-selects') || (fs ? fs.parentElement : null);
    if (container) {
      this.mo = new MutationObserver(function () {
        if (self._applying) return;
        self._applying = true;
        self.stamp();
        self.apply(self.current);
        setTimeout(function () { self._applying = false; }, 0);
      });
      this.mo.observe(container, { childList: true, subtree: true });
    }
    document.addEventListener('variant:change', function () {
      if (self._applying) return;
      self._applying = true;
      self.stamp();
      self.apply(self.current);
      setTimeout(function () { self._applying = false; }, 0);
    });
  };

  SxSizeToggle.prototype.fieldset = function () {
    var fs = document.querySelector('.sx-pdp__sizes--size');
    if (fs) return fs;
    var inp = document.querySelector('input[name="Size"]');
    return inp ? inp.closest('fieldset') : null;
  };
  SxSizeToggle.prototype.labels = function () {
    var fs = this.fieldset();
    return fs ? [].slice.call(fs.querySelectorAll('label')) : [];
  };
  SxSizeToggle.prototype.stamp = function () {
    this.labels().forEach(function (label) {
      if (label.querySelector('[data-sx-size-text]')) return;
      var us = '';
      var prev = label.previousElementSibling;
      if (prev && prev.tagName === 'INPUT') us = prev.value;
      if (!us) { var f = label.getAttribute('for'); var i = f && document.getElementById(f); if (i) us = i.value; }
      if (!us) us = (label.textContent || '').trim();
      var span = document.createElement('span');
      span.setAttribute('data-sx-size-text', '');
      span.setAttribute('data-us', us);
      span.textContent = us.replace(/^US\s?/i, 'US');
      // drop the label's leading text node(s), keep element children (a11y span)
      var n = label.firstChild;
      while (n && n.nodeType === 3) { var nx = n.nextSibling; label.removeChild(n); n = nx; }
      label.insertBefore(span, label.firstChild);
    });
  };
  SxSizeToggle.prototype.apply = function (sys) {
    this.current = sys;
    this.labels().forEach(function (label) {
      var span = label.querySelector('[data-sx-size-text]');
      if (!span) return;
      var us = span.getAttribute('data-us');
      var conv = convert(us, sys);
      span.textContent = conv || us.replace(/^US\s?/i, 'US');
    });
    this.gh3apply(sys);
  };
  // The gh3 StockX PDP renders its own size chips (.gh2__sizes button[data-v])
  // that are NOT Dawn radio labels, so the loop above never reaches them (the
  // toggle looked dead on sneaker pages). Convert those chips too, preserving
  // data-v — the canonical US value the gh3 variant-matcher reads — and stash
  // the original US label in data-sx-us so repeat conversions stay lossless.
  SxSizeToggle.prototype.gh3apply = function (sys) {
    var chips = document.querySelectorAll('.gh2__sizes [data-v], .gh2__sw[data-seg="size"] [data-v]');
    [].forEach.call(chips, function (b) {
      var us = b.getAttribute('data-sx-us');
      if (!us) { us = b.getAttribute('data-v') || (b.textContent || '').trim(); b.setAttribute('data-sx-us', us); }
      var conv = convert(us, sys);
      b.textContent = conv || us.replace(/^US\s?/i, 'US');
    });
  };

  if (!customElements.get('sx-size-toggle')) customElements.define('sx-size-toggle', SxSizeToggle);

  function openChart() {
    var m = document.getElementById('sx-size-chart');
    if (!m) return;
    if (m.tagName === 'DIALOG' && typeof m.showModal === 'function') m.showModal();
    else m.classList.add('is-open');
    document.body.classList.add('sx-no-scroll');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sx-close-chart]') || e.target.id === 'sx-size-chart') {
      var m = document.getElementById('sx-size-chart');
      if (!m) return;
      if (m.close) try { m.close(); } catch (x) {}
      m.classList.remove('is-open');
      document.body.classList.remove('sx-no-scroll');
    }
  });
})();
